











































import {Component, Vue} from 'vue-property-decorator';
import {mapActions, mapGetters, mapState} from 'vuex';
import {Paging} from '@/models/PlanModel';
import {PAGINATION_ROW_COUNT_SIZES} from '@/configs/constants';

@Component({
    computed: {
        ...mapGetters('plan', ['pagination']),
        ...mapState('plan', ['currentPageIndex', 'currentRowCount']),
    },
    methods: {
        ...mapActions('plan', ['getData']),
    },
})
export default class PlanFooter extends Vue {
    public pagination!: Paging | undefined;
    public currentPageIndex!: number;
    public currentRowCount!: number;
    public getData!: Function;

    private rowCountSizes = PAGINATION_ROW_COUNT_SIZES;

    onRefresh() {
        this.getData({
            pageIndex: this.currentPageIndex,
            rowCount: this.currentRowCount,
        });
    }

    onPaginationIndexChange(pageIndex: number) {
        this.getData({pageIndex, rowCount: this.currentRowCount});
    }

    onPaginationRowCountChange(value: any) {
        this.getData({pageIndex: this.currentPageIndex, rowCount: +value});
    }
}
